import { useContext } from 'react';
import { FacebookPixelContext } from '../components/wrappers/FacebookPixelWrapper';

const useFacebookPixel = () => useContext(FacebookPixelContext) || {};

export default useFacebookPixel;
